import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { motion } from 'framer-motion';
import { ArrowBack, ChevronForward } from 'react-ionicons';

const TodayButton = ({
  onClick,
  isFuture,
}: {
  onClick: () => void;
  isFuture: boolean;
}) => {
  return (
    <motion.div
      layout
      transition={{ duration: 0.4, ease: 'easeInOut' }}
      className="m-1 flex h-6"
    >
      <GraniteButton size="small" variant="secondary" onClick={onClick}>
        {isFuture ? (
          <>
            <ArrowBack width="18px" height="18px" /> Today
          </>
        ) : (
          <>
            Today <ChevronForward width="18px" height="18px" />
          </>
        )}
      </GraniteButton>
    </motion.div>
  );
};

export default TodayButton;
